import React, { useState, useEffect } from 'react';

export const avatarColor = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return `hsl(${((hash % 360) + 360) % 360}, 45%, 45%)`;
};

export const getInitials = (name) => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// WordPress thumbnails carry a size suffix (e.g. NAME-70x70.jpg); the
// full-size original lives at the same path without it.
export const stripSizeSuffix = (src) => src.replace(/-\d+x\d+(\.[A-Za-z0-9]+)$/, '$1');

export const PerformerAvatar = ({ name, image, onEnlarge, className = 'w-12 h-12' }) => {
  const [failed, setFailed] = useState(false);

  if (image && !failed) {
    return (
      <img
        src={image}
        alt={`${name} headshot`}
        loading="lazy"
        onError={() => setFailed(true)}
        onClick={(e) => {
          e.stopPropagation();
          onEnlarge();
        }}
        role="button"
        aria-label={`Enlarge ${name} headshot`}
        className={`${className} rounded-full object-cover shrink-0 cursor-pointer`}
      />
    );
  }

  return (
    <div
      className={`flex items-center justify-center rounded-full ${className} font-semibold shrink-0 text-white`}
      style={{ backgroundColor: avatarColor(name) }}
    >
      {getInitials(name)}
    </div>
  );
};

export const Lightbox = ({ name, image, onClose }) => {
  // Try the full-size original first; fall back to the thumbnail on error
  const [src, setSrc] = useState(() => stripSizeSuffix(image));

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center fadeIn"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
      onClick={onClose}
    >
      <img
        src={src}
        alt={`${name} headshot`}
        onError={() => {
          if (src !== image) setSrc(image);
        }}
        onClick={(e) => e.stopPropagation()}
        className="rounded-lg object-contain"
        style={{ maxWidth: '90vw', maxHeight: '80vh' }}
      />
      <p className="text-white text-lg mt-3">{name}</p>
    </div>
  );
};
